/* eslint-disable @next/next/no-img-element */
'use client';

import React from 'react';
import Image from 'next/image';

interface ImageWrapperProps {
  url: string;
  alt?: string;
  svgContent?: string;
  className?: string;
  imgClassName?: string;
  width?: number;
  height?: number;
  fill?: boolean;
  sizes?: string;
}

const ImageWrapper: React.FC<ImageWrapperProps> = ({
  url,
  alt,
  svgContent,
  className,
  imgClassName,
  width,
  height,
  fill = false,
  sizes,
}) => {
  const altAttribute = alt || 'alt text not found';
  const isSvg = url?.endsWith('.svg');

  // Inline SVG (optional)
  if (isSvg && svgContent) {
    return (
      <div className={className}>
        <img
          className={imgClassName ?? ''}
          src={url + '?fm=webp&q=50'}
          alt={altAttribute}
        />
      </div>
    );
  }

  // SVG without inline content → render with <img>
  if (isSvg) {
    return (
      <div className={className}>
        <img className={imgClassName ?? ''} src={url} alt={altAttribute} />
      </div>
    );
  }

  // Determine appropriate sizes prop based on usage
  const getImageSizes = () => {
    if (sizes) return sizes;

    // Default sizes for different scenarios
    if (fill) {
      return '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw';
    }
    return undefined;
  };

  // Non-SVG → use Next.js optimized image
  return (
    <div className={`${className || ''} ${fill ? 'absolute inset-0' : ''}`}>
      {/* <Image
        className={imgClassName ?? ''}
        src={url}
        alt={alt}
        fill={fill}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        sizes={getImageSizes()}
        quality={60}
      /> */}
      <img
        src={url + '?fm=webp&q=50'}
        className={`${fill ? 'w-full h-full' : ''} ${imgClassName ?? ''}`.trim()}
        alt={alt}
      />
    </div>
  );
};

export default ImageWrapper;
